export const styles = {
  container: {
    position: "relative",
    height: "100%",
    backgroundColor: "#fff",
    paddingTop: "16px",
    overflowY: "auto",
  },
  postsWrapper: {
    borderTop: "2px solid #f7f7f7",
  },
  emptyBox: {
    height: "48vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "24px",
    color: "#8C8C8C",
    fontSize: "14px",
  },
};
